import { Token } from '../text-diff/diff';

export const getTokensCharsLength = (tokens: Token[]): number =>
  tokens.reduce(
    (result, token) => result + (typeof token === 'string' ? token.length : token[0].length),
    0,
  );
